import { Box, Button, Flex, HStack, Spinner, Text } from '@chakra-ui/react'
import { CardColaborador } from './components/CardColaborador'
// import imgPerfil from '../../../../assets/pi/perfil.png'
import { IJobTarget } from '../../JobTarget/Create'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
interface ITabelaAderencia{
  titulo: String
  job?: IJobPerfis
  paginaAtual: number
  numeroPaginas: number
  isLoading: boolean
  next: VoidFunction
  prev: VoidFunction
}

interface IperfilBa{
  id?: string
  nome: string
  dataPesquisa: Date
  perfil: string
  urlImgPerfil?: string
}
interface IperfilDto{
  perfil: IperfilBa
  outrosCargos: IOutrosCargos[]
}

interface IOutrosCargos{
  nome: string
  jobId: string
}
interface IJobPerfis{
  jobTarget: IJobTarget
  numeroPerfis: number
  numeroPerfisAdaptativos: number
  numeroPerfisAderentes: number
  numeroPerfisNaoAderentes: number
  perfis: IperfilDto[]

}

export const TabelaAderencia: React.FC<ITabelaAderencia> = ({ titulo, job, numeroPaginas, paginaAtual, next, prev, isLoading }: ITabelaAderencia) => {
  function obterTipoPerfil(perfil: string): number {
    if (job?.jobTarget !== undefined) {
      if (job.jobTarget.perfisAderentes.includes(perfil)) return 0
      if (job.jobTarget.perfisAdaptativos.includes(perfil)) return 1
    }
    return 2
  }
  return (
    <>
    <Flex mr={4} mt={0} justifyContent='end'>

    {numeroPaginas > 1 &&

(<HStack mt={0} mx={5} borderTop='2px'
 borderLeft='2px' borderRight='2px' borderTopLeftRadius='2xl' borderTopRightRadius='2xl' p={2} borderColor='var(--c4)' backgroundColor='#fcfbf4'>
      <Text>Página:</Text>
      <Button size='xs' onClick={prev} bgColor='var(--a1)'><FaArrowLeft/></Button>
      <Text>{paginaAtual + 1} / {numeroPaginas}</Text>
      <Button size='xs' onClick={next} bgColor='var(--a1)'><FaArrowRight/></Button>

      </HStack>
)}
</Flex>
 <Box border='2px' borderRadius='8px' borderColor='var(--c4)' mb={4} mx={4} px={4}>

  <Flex flexDir='column'>

<Flex justifyContent='space-between' mt={0} p={4} color='var(--Gray3)'>
<Text fontSize='12px' width='12rem' textAlign='center'
fontWeight='bold'
>Colaborador</Text>
<Text fontSize='12px' width='8rem' textAlign='center'
fontWeight='bold'
>Data da pesquisa</Text>
<Text fontSize='12px' width='12rem' textAlign='center'
fontWeight='bold'
>Perfil</Text>
<Text fontSize='12px' width='8rem' textAlign='center'
fontWeight='bold'
>Aderência</Text>
<Text
fontSize='12px' width='12rem' textAlign='center'
fontWeight='bold'
>Outros cargos aderentes</Text>

</Flex>
<Flex flexDir='column' overflowY='auto' height='22rem'>
  <Box alignSelf='end'>
      {isLoading && (

        <HStack>
      <Text m={2}>Carregando perfis...</Text>
      <Spinner
  thickness='4px'
  speed='0.65s'
  emptyColor='gray.200'
  color='red.500'
  size='lg'
/>
</HStack>
      )}

  </Box>
{job?.perfis.map((j, i) => {
  return (<CardColaborador
    key={j.perfil.id}
    imgPerfil={j.perfil.urlImgPerfil}
    avatar={''}
    cargos={j.outrosCargos}
    dataPesquisa={'22/10/2022'}
    nome={j.perfil.nome}
    tipo={obterTipoPerfil(j.perfil.perfil)}
    perfil={j.perfil.perfil}
    par={i % 2 !== 0}
    />)
})}

  </Flex>
  </Flex>
  </Box>
  </>
  )
}
